import './ticket_count_card_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.InAttentionTicketsView extends CustomerVisualMode.Charts.TicketCountCardView

  initialize: ({clickable, count}) ->
    @id = 'in_attention_tickets'
    @clickable = clickable
    @count = count
    @statusClass = 'in-attention-tickets'
    @title = I18n.t('customer_visual_mode.charts.ticket_count.in_attention')

  render: ->
    super()
    @$el.html @template
      clickable: @clickable
      count: @count
      precision: 0
      unit: ''
      iconClass: @iconClass
      title: @title
    @$('.status-icon').html(@_iconView().render().el)
    @

  _iconView: ->
    new Common.SvgIconView(
      svgPath: 'icons/status-assigned.svg'
      svgId: 'status-assigned'
      iconClass: 'status-icon'
    )
